import { AlertTriangle } from 'lucide-react';

interface Props {
  channel: string;
  lastInboundAt?: number;
}

// Surfaces Meta's 24h customer-service window state to the agent so they don't
// waste time typing a free-form reply that the policy module will reject.
// Renders nothing for channels that don't have a window (email, web, sms).
export function WindowBanner({ channel, lastInboundAt }: Props) {
  if (channel !== 'whatsapp' && channel !== 'facebook') return null;
  const expired = !lastInboundAt || Date.now() - lastInboundAt >= 24 * 60 * 60 * 1000;
  if (!expired) return null;

  const fallback = channel === 'whatsapp'
    ? 'Pick an approved template to reply.'
    : 'Pick an allowed Messenger tag (post-purchase / account / event update) or use Human Agent.';
  return (
    <div className="flex items-start gap-2 px-3 py-2 mx-2 mb-1 rounded-md border border-amber-300 bg-amber-50 text-amber-900 text-xs">
      <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" />
      <div>
        <div className="font-medium">24-hour window expired</div>
        <div>{fallback}</div>
      </div>
    </div>
  );
}
